import {ActConfiguration} from "../act-configuration.model";
import {ActRequiredFileCategories} from "./required-file-categories/act-required-file-categories.model";

export class ProjectSettings {
  allowPostal: boolean = false;
  aktConfiguration: ActConfiguration = new ActConfiguration();
  enableAddress: boolean = false;
  enableCompanyField: boolean = false;
  redirectToStep2: boolean = false;
  redirectToStep3: boolean = false;
  requiredFileCategories: any[] = [];
  sendSms: boolean = false;
  step1: boolean = false;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;
  // renmaing for Version2
  stepLeadGeneartion?: boolean = false;
  stepAct?: boolean = false;
  stepValuesInDispute?: boolean = false;
  stepContract?: boolean = false;
  streitwertConfiguration?: Object = {};
  streitwertRequiredFileCategories?: ActRequiredFileCategories[] = [];
  title: string = '';
  visible: boolean = false;
  websiteURL?: string = '';


}
